import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { StepNavigation } from '@eg/elements/StepNavigation';

class CheckoutNavigation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeStepIndex: this.props.step,
    };
  }

  goToStep = (index) => {
    this.redirect(index);
    this.setState({
      activeStepIndex: index
    });
  };

  redirect = (index) => {
    if(index === 0) {
      this.props.history.push("/internet-schutzbrief/tarifdaten");
    } else if(index === 1) {
        this.props.history.push("/internet-schutzbrief/persoenliches");
    } else if(index === 2) {
      this.props.history.push("/internet-schutzbrief/bezahlmethode");
    }
  }

  goToNextStep = () => {
    this.goToStep(this.props.step);
  };

  render() {
    const steps = [
      'Tarifdaten',
      'Persönliches',
      'Bezahlung',
      'Abschluss',
    ];
    return(
      <div>
        <StepNavigation activeStepIndex={Number(this.state.activeStepIndex)} steps={steps} goToStepByIndex={this.goToStep} />
      </div>
    );
  }
}

export default withRouter (CheckoutNavigation);
